import styled, { css } from 'styled-components';

import { Text } from '../Typography/Text';

export const Clickable = styled.button`
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    ${({ theme }) => css`
        transition: all ${theme.transitions.hover};
        ${Text} {
            transition: all ${theme.transitions.hover};
        }
        &:hover {
            color: ${theme.colors.logoPrimary};
            ${Text} {
                color: ${theme.colors.logoPrimary};
            }
        }
    `}
    &:disabled {
        color: ${({ theme }) => theme.colors.fontPrimaryDisabled};
        cursor: not-allowed;

        &:hover {
            box-shadow: none;
            color: ${({ theme }) => theme.colors.fontPrimaryDisabled};
        }
    }
`;
